<template>
  <div class="b-capsule-content">
    <b-row class="justify-content-center">
      <b-col
        cols="6"
        sm="3"
        md="3"
        lg="3"
        class="layer-wrapper p-2"
        ref="capsuleLayerTopRow"
        v-for="(layer, index) in topRow"
        :key="index"
      >
        <CapsuleLayer :layer="layer" />
      </b-col>
    </b-row>

    <b-row class="justify-content-center">
      <b-col
        cols="6"
        sm="3"
        md="3"
        lg="3"
        class="layer-wrapper p-2"
        ref="capsuleLayerBottomRow"
        v-for="(layer, index) in bottomRow"
        :key="index"
      >
        <CapsuleLayer :layer="layer" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CapsuleLayer from "@/components/landing/capsuleAnatomy/CapsuleLayer";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    CapsuleLayer
  },

  created() {
    if (this.temporaryOutfits.length == 0) this.createDummyTempOutfit();
  },

  data() {
    return {
      topRow: [
        {
          id: 1,
          name: "Outerwear",
          products: [
            { id: 101, featured_image: "outerwear01" },
            { id: 102, featured_image: "outerwear02" }
          ]
        },
        {
          id: 2,
          name: "Midwear",
          products: [
            { id: 201, featured_image: "midwear01" },
            { id: 202, featured_image: "midwear02" },
            { id: 203, featured_image: "midwear03" }
          ]
        },
        {
          id: 3,
          name: "Innerwear",
          products: [
            { id: 301, featured_image: "innerwear01" },
            { id: 302, featured_image: "innerwear02" },
            { id: 303, featured_image: "innerwear03" }
          ]
        },
        {
          id: 4,
          name: "Shorts & Trousers",
          products: [
            { id: 401, featured_image: "bottoms01" },
            { id: 402, featured_image: "bottoms02" }
          ]
        }
      ],

      bottomRow: [
        {
          id: 5,
          name: "Footwear",
          products: [
            { id: 501, featured_image: "footwear01" },
            { id: 502, featured_image: "footwear02" },
            { id: 503, featured_image: "footwear03" }
          ]
        },
        {
          id: 6,
          name: "Accessories",
          products: [
            { id: 601, featured_image: "accessories01" },
            { id: 602, featured_image: "accessories02" },
            { id: 603, featured_image: "accessories03" }
          ]
        },
        {
          id: 7,
          name: "Accessories",
          products: [
            { id: 704, featured_image: "accessories04" },
            { id: 705, featured_image: "accessories05" },
            { id: 706, featured_image: "accessories06" }
          ]
        }
      ]
    };
  },

  computed: {
    ...mapGetters(["temporaryOutfits"])
  },

  methods: {
    ...mapActions(["addTemporaryOutfit"]),

    clicker() {
      const payload = {
        topRow: this.getFilenames(this.$refs.capsuleLayerTopRow),
        bottomRow: this.getFilenames(this.$refs.capsuleLayerBottomRow)
      };

      this.addTemporaryOutfit(payload);
    },

    getFilenames(list) {
      const results = list.map(el => {
        const product = el.getElementsByClassName(
          "swiper-slide swiper-slide-active"
        );
        return product[0].dataset["filename"];
      });

      return results;
    },

    createDummyTempOutfit() {
      const payload = {
        topRow: [
          { layerId: 1, productId: 102, filename: "outerwear02" },
          { layerId: 2, productId: 202, filename: "midwear02" },
          { layerId: 3, productId: 303, filename: "innerwear03" },
          { layerId: 4, productId: 402, filename: "bottoms02" }
        ],
        bottomRow: [
          { layerId: 5, productId: 503, filename: "footwear03" },
          { layerId: 6, productId: 602, filename: "accessories02" },
          { layerId: 7, productId: 706, filename: "accessories06" }
        ]
      };

      this.addTemporaryOutfit(payload);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

.b-capsule-content {
  transition: all 0.3s;
}
</style>



// WEBPACK FOOTER //
// src/components/landing/capsuleAnatomy/CapsuleContent.vue